import { useCallback, useMemo } from "react";

import { useQuery } from "hooks";

function useQueryNotInvitedUsers(loadNotInvitedUser) {
  const queryFactory = useCallback(() => {
    const query = `query notInvited {
      advisors(isInvited: false, excludeSupportUser: true) {
        edges {
          node {
            id
            firstName
            lastName
            email
            role {
              id
            }
          }
        }
      }
    }`;

    const resolver = ({
      data: {
        advisors: { edges },
      },
    }) => {
      return edges.map(({ node }) => {
        return { ...node };
      });
    };

    return { query, resolver };
  }, []);

  const {
    loading,
    data = [],
    error,
    numOfFetches,
    reloadData: reloadNotInvitedUsers,
  } = useQuery(queryFactory, {
    options: useMemo(() => {
      return { fetchOnInit: loadNotInvitedUser };
    }, [loadNotInvitedUser]),
  });

  const userList = useMemo(() => {
    return data.map(({ id, role: { id: roleId }, ...rest }) => {
      return {
        roleId: roleId,
        inviteNow: false,
        advisorId: id,
        ...rest,
      };
    });
  }, [data]);

  return {
    userList: userList,
    loading: loading || (numOfFetches === 0 && !error && loadNotInvitedUser),
    error: error,
    reloadNotInvitedUsers: reloadNotInvitedUsers,
  };
}

export default useQueryNotInvitedUsers;
